import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = { type: String }

  connect() {
    this.show()
    this.autoDismiss()
  }

  show() {
    // Remove the translate-x-full and opacity-0 classes to show the toast
    this.element.classList.remove("translate-x-full", "opacity-0")
    this.element.classList.add("translate-x-0", "opacity-100")
  }

  dismiss() {
    // Add classes to hide the toast
    this.element.classList.add("translate-x-full", "opacity-0")
    this.element.classList.remove("translate-x-0", "opacity-100")
    
    // Remove the element after the transition
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  autoDismiss() {
    // Auto-dismiss after 5 seconds minimum, 8 seconds for errors
    const dismissTime = this.typeValue === "error" || this.typeValue === "alert" ? 8000 : 5000
    
    setTimeout(() => {
      this.dismiss()
    }, dismissTime)
  }
}
